import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import useLoading from "../../hooks/useLoading";
import useToast from "../../hooks/useToast";
import { useEffect, useState } from "react";
import { getStripDetailRanges, getStripInfos, getStripItems, updateStripDetailRanges } from "../../services/ api_services";
import { CiSquareMinus, CiSquarePlus } from "react-icons/ci";
import { ToastTypes } from "../../context/ToastProvider";
import { CiSaveDown1 } from "react-icons/ci";
import SelectMenu from "../../components/SelectMenu";
import { isArray, isEmpty } from "lodash";
import { useDialog } from "../../hooks/useDialog";
import { DialogTypes } from "../../context/DialogProvider";
import axios from "axios";
import { Switch } from "@headlessui/react";

const HP_KINDS = [
    { id: "0001", name: "안드로이드" },
    { id: "0002", name: "아이폰" },
];

const initConds = {
    custSeq: "",
    stripId: "",
    groupCode: "0001",
    specCode: "",
    hpKind: HP_KINDS[0].id,
};

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

export default function UrinalysisManagement() {
    const { setLoading } = useLoading();
    const { showToast } = useToast();
    const { showDialog } = useDialog();

    const [conds, setConds] = useState(initConds);
    const [stripTypes, setStripTypes] = useState([]);
    const [list, setList] = useState([]);
    const [colorTypes, setColorTypes] = useState([]);
    const [stripItems, setStripItems] = useState([]);
    const [selectedStripItem, setSelectedStripItem] = useState();
    const [expandedDivs, setExpandedDivs] = useState({});

    let cancelconds;
    const MAX_LENGTH = 8;

    useEffect(() => {
        fetchStripInfos();
        clearInitialValues();
    }, []);

    useEffect(() => {
        if (conds && (conds.custSeq || conds.stripId)) {
            clearInitialValues();
            fetchStripItems();
        }

        return () => {
            if (cancelconds) {
                cancelconds();
            }
        };
    }, [conds.custSeq, conds.stripId]);

    useEffect(() => {
        onHandleClickSearchButton();
    }, [conds.groupCode, conds.specCode]);

    useEffect(() => {
        if (!isEmpty(conds.groupCode) && !isEmpty(conds.specCode)) {
            onHandleClickSearchButton();
        }
    }, [conds.hpKind]);

    useEffect(() => {
        if (list && !isEmpty(list)) {
            const seen = new Set();
            const filteredColorTypes = list.filter((item) => {
                const key = `${item.color_type}-${item.color_nm}`;
                return seen.has(key) ? false : seen.add(key);
            });
            setColorTypes(
                filteredColorTypes.map((item) => {
                    return {
                        color_nm: item.color_nm,
                        color_type: item.color_type,
                    };
                })
            );
        }
    }, [list]);

    const clearInitialValues = () => {
        setStripItems([]);
        setColorTypes([]);
        setExpandedDivs({});
        setList([]);
    };

    /**
     * Clear main list values
     */
    const clearListValues = () => {
        setColorTypes([]);
        setExpandedDivs({});
        setList([]);
    };

    /**
     * Fetch main grid all datas...
     * 기존 그리드 데이터를 API으로 가져오기
     */
    const fetchDatas = async () => {
        setLoading(true);

        const request = {
            cust_seq: conds.custSeq,
            strip_id: conds.stripId,
            group_code: conds.groupCode,
            spec_code: conds.specCode,
            hp_kind: conds.hpKind,
        };

        if (!request.cust_seq || !request.strip_id) return;
        console.log("🚀 ~ fetchDatas ~ request:", request);
        const { data, cancel, error } = await getStripDetailRanges(request);
        cancelconds = cancel;
        if (data) {
            showToast(ToastTypes.SUCCESS, "성공", "조회를 완료했습니다.");
            if (!isEmpty(data)) {
                console.log("Data ==> ", data);
                setList(data);
            } else {
                clearListValues();
            }
        } else if (error) {
            console.log("Error ==> ", error);
            showToast(ToastTypes.ERROR, "오류", error);
            clearListValues();
        }

        setLoading(false);
    };

    // useEffect(() => {
    //     console.table("LIST UPDATED ==> ", list);
    // }, [list]);

    // 스트립 항목명들을 호출 API
    async function fetchStripItems() {
        // console.log("🚀 ~ fetchStripItems ~ stripId:", conds.stripId);
        // console.log("🚀 ~ fetchStripItems ~ custSeq:", conds.custSeq);

        setLoading(true);

        const params = {
            cust_seq: conds.custSeq,
            strip_id: conds.stripId,
        };

        try {
            const { data, cancel, error } = await getStripItems(params);
            cancelconds = cancel;

            if (data) {
                // console.log("🚀 ~ convertedData ~ data:", data);
                if (!isEmpty(data) && isArray(data)) {
                    const convertedData = data.map((item) => {
                        return {
                            id: item.spec_code,
                            name: item.spec_nm,
                            groupCode: item.group_code,
                        };
                    });
                    // console.log("🚀 ~ fetchStripItems ~ convertedData:", convertedData);

                    setStripItems(convertedData);
                    setConds((preVal) => {
                        return {
                            ...preVal,
                            specCode: convertedData[0].id,
                        };
                    });
                }
            } else if (error) {
                console.log("[fetchStripItems][Error] ==> ", error);
                showToast(ToastTypes.ERROR, "오류", error);
                setStripItems([]);
            }

            setLoading(false);
        } catch (e) {
            setLoading(false);
            setStripItems([]);
            if (axios.isCancel(e)) {
                //console.log("요청이 취소되었습니다:", e.message);
            } else {
                console.error("Error fetching data: ", e);
            }
        }
    }

    // 스트립 타입들을 호출 API
    async function fetchStripInfos() {
        setLoading(true);
        const { data, cancel, error } = await getStripInfos();
        cancelconds = cancel;
        if (data) {
            console.log("[fetchStripInfos][Data] ==> ", data);
            const convertedData = data.map((item) => {
                return {
                    id: item.cust_seq + "_" + item.strip_id,
                    custSeq: item.cust_seq,
                    stripId: item.strip_id,
                    name: item.strip_nm + " (" + item.strip_model_nm + ")",
                };
            });
            console.log("🚀 ~ convertedData ~ convertedData:", convertedData);
            setStripTypes(convertedData);
            setConds((preVal) => {
                return {
                    ...preVal,
                    custSeq: convertedData[0].custSeq,
                    stripId: convertedData[0].stripId,
                };
            });
        } else if (error) {
            console.log("[fetchStripInfos][Error] ==> ", error);
            showToast(ToastTypes.ERROR, "오류", error);
            setStripTypes([]);
        }
        setLoading(false);
    }

    async function updateStripDetailRangesRequest() {
        console.log("[Update strip detail][START]");
        console.log("[Update strip detail][List] ==> ", list);
        setLoading(true);
        const { data, cancel, error } = await updateStripDetailRanges({ data: list });
        cancelconds = cancel;
        if (data) {
            console.log("[updateStripDetailRangesRequest][Data] ==> ", data);
            if (data.resultCode === 200 && data.message === "Successfully updated list") {
                showToast(ToastTypes.SUCCESS, "성공", "저장을 완료했습니다.");
                fetchDatas();
            }
        } else if (error) {
            console.log("[updateStripDetailRangesRequest][Error] ==> ", error);
            showToast(ToastTypes.ERROR, "오류", error);
        }
        setLoading(false);
    }

    /**
     * 저장 버튼 클릭 이벤트
     */
    const handleOnClickSave = () => {
        console.log("SAVE START ===> ");
        showDialog(
            DialogTypes.REQUEST,
            "데이터 저장 확인",
            "변경된 스트립 상세 데이터를 저장하시겠습니까? 저장된 후에는 이 작업을 되돌릴 수 없습니다.",
            () => {
                console.log("🚀 ~ handleOnClickSave ~ list:", list);
                if (list == null || isEmpty(list)) {
                    showToast(ToastTypes.WARNING, "안내", "저장할 데이터가 없습니다. 먼저 항목을 선택해 주세요");
                    return;
                } else {
                    updateStripDetailRangesRequest();
                    console.log("SAVE END ===> ");
                }
            }
        );
    };

    const getTableItems = (colorType) => {
        // console.log("🚀 ~ getTableItems ~ colorType:", colorType);
        const filteredTableItems = list.filter((item) => item.color_type === colorType);
        // console.log("🚀 ~ getTableItems ~ filteredTableItems:", filteredTableItems);

        return filteredTableItems;
    };

    /**
     * 사용여부 값을 항목별로 가져오기
     */
    const getUseYn = (colorType) => {
        const filteredItem = list.find((item) => item.color_type === colorType);
        if (filteredItem) {
            return filteredItem.use_yn === "Y";
        }
        return false;
    };

    // useEffect(() => {
    //     console.log("expandedDivs ==> ", expandedDivs);
    // }, [expandedDivs]);

    /**
     * 색삭 별로 그리드의 DIV를 펼치는 함수
     * @param {펼치는 div 컬러 아이디} id
     */
    const toggleExpand = (id) => {
        // console.log("🚀 ~ toggleExpand ~ id:", id);
        setExpandedDivs((preState) => ({
            ...preState,
            [id]: !preState[id],
        }));
    };

    const isExpanded = (colorType) => {
        return expandedDivs && expandedDivs[colorType];
    };

    /**
     * 조회 버튼 클릭 이벤트 핸들 함수
     */
    const onHandleClickSearchButton = async () => {
        // console.log("🚀 ~ onHandleClickSearchButton ~ stripItems:", stripItems);
        const foundSelectedStripItem = stripItems.find((item) => item.id === conds.specCode && item.groupCode === conds.groupCode);
        if (foundSelectedStripItem) {
            setSelectedStripItem(foundSelectedStripItem);
        }

        fetchDatas();
    };

    const setUseYn = (colorType, state) => {
        // console.log("COLOR TYPE ==> ", colorType);
        // console.log("STATE ==> ", state);
        setList((preItems) => preItems.map((item) => (item.color_type === colorType ? { ...item, use_yn: state ? "Y" : "N" } : item)));
    };

    const handleOnChangeRangeWeight = (colorType, value) => {
        console.log("COLOR TYPE ==> ", colorType);
        console.log("STATE ==> ", value);
        if (value.length <= MAX_LENGTH) {
            setList((preItems) =>
                preItems.map((item) => (item.color_type === colorType ? { ...item, range_weight: parseFloat(value) } : item))
            );
        }
    };

    const getRangeWeight = (colorType) => {
        if (list == null || isEmpty(list)) return 0;
        const foundColor = list.find((item) => item.color_type === colorType);
        return foundColor.range_weight;
    };

    /**
     * 범위값 입력을 핸들하는 함수
     * @param {색상 종류} colorType
     * @param {단계} inspLevel
     * @param {항목 type} itemType
     * @param {입력 값} val
     */
    const handleValueChange = (colorType, inspLevel, itemType, val) => {
        // console.log("🚀 ~ handleValueChange ~ colorType:", colorType);
        // console.log("🚀 ~ handleValueChange ~ inspLevel:", inspLevel);
        // console.log("🚀 ~ handleValueChange ~ itemType:", itemType);
        // console.log("🚀 ~ handleValueChange ~ val:", val);
        if (val.length <= MAX_LENGTH) {
            setList((preItems) =>
                preItems.map((item) =>
                    item.color_type === colorType && item.insp_level === inspLevel ? { ...item, [itemType]: parseFloat(val) } : item
                )
            );
        }
    };

    const handleToggleValue = (colorType, inspLevel, itemType, val) => {
        // console.log("🚀 ~ handleValueChange ~ colorType:", colorType);
        // console.log("🚀 ~ handleValueChange ~ inspLevel:", inspLevel);
        // console.log("🚀 ~ handleValueChange ~ itemType:", itemType);
        // console.log("🚀 ~ handleValueChange ~ val:", val);
        setList((preItems) =>
            preItems.map((item) =>
                item.color_type === colorType && item.insp_level === inspLevel ? { ...item, [itemType]: val ? "Y" : "N" } : item
            )
        );
    };

    return (
        <div className="mx-auto max-w-full">
            <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8 px-6 bg-white  rounded-md">
                <span className="flex text-center justify-center align-middle text-nowrap text-gray-900 font-semibold text-xl">
                    소변검사 스트립 항목 설정
                </span>
            </div>
            <div className="w-full max-w-full my-4 bg-slate-50 border-gray-200 rounded-md border p-4 justify-start items-center">
                <div className="px-2 py-2 grid grid-cols-10 gap-x-4 gap-y-4 sm:grid-cols-10 items-center">
                    <>
                        <div className="col-span-3">
                            <SelectMenu
                                options={stripTypes}
                                labelText={"스트립 타입"}
                                selectedId={conds.custSeq + "_" + conds.stripId}
                                onSelect={(val) => {
                                    // setSelectedStripType(val.id);
                                    setConds((preVal) => {
                                        return {
                                            ...preVal,
                                            custSeq: val.custSeq,
                                            stripId: val.stripId,
                                        };
                                    });
                                }}
                            />
                        </div>
                        <div className="col-span-3">
                            <SelectMenu
                                options={stripItems}
                                onSelect={(val) => {
                                    // console.log("SELECT val ==> ", val);
                                    setConds((preVal) => {
                                        return {
                                            ...preVal,
                                            specCode: val.id,
                                            groupCode: val.groupCode,
                                        };
                                    });
                                }}
                                labelText={"항목명"}
                            />
                        </div>
                        <div className="col-span-3">
                            <SelectMenu
                                options={HP_KINDS}
                                onSelect={(val) => {
                                    setConds((preVal) => {
                                        return {
                                            ...preVal,
                                            hpKind: val.id,
                                        };
                                    });
                                }}
                                labelText={"디바이스 타입"}
                            />
                        </div>
                    </>
                    <>
                        <div className="col-span-10 flex justify-end">
                            <button
                                type="button"
                                className="w-24 rounded inline-flex gap-x-1 items-center justify-center mr-4 bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                                onClick={() => {
                                    onHandleClickSearchButton();
                                }}
                            >
                                <MagnifyingGlassIcon className="-ml-0.5 h-5 w-5" aria-hidden="true" />
                                조회
                            </button>
                            <button
                                type="button"
                                className="w-24 rounded inline-flex gap-x-1 items-center justify-center bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
                                onClick={() => handleOnClickSave()}
                            >
                                <CiSaveDown1 className="-ml-0.5 h-5 w-5" aria-hidden="true" />
                                저장
                            </button>
                        </div>
                    </>
                </div>
            </div>
            {colorTypes && !isEmpty(colorTypes) && selectedStripItem && (
                <div className="bg-white border-gray-200 rounded-md ">
                    <div className="sm:flex-auto p-3 shadow-sm ring-1 ring-black ring-opacity-5 sm:rounded-sm text-center">
                        <h2 className="text-2xl font-bold leading-6 text-gray-900 ">{selectedStripItem.name}</h2>
                    </div>
                    {colorTypes.map((item, index) => (
                        <div key={index} className="mt-4">
                            <div className="bg-slate-100 pl-3 grid grid-cols-2 items-center overflow-x-auto z-50 shadow-md ring-1 ring-black ring-opacity-5 sm:rounded-sm">
                                {/* <label className="col-span-1">{item.color_nm}</label> */}
                                <h3 className="text-base font-bold leading-6 text-gray-900  px-10 py-1 w-fit min-w-36 rounded">
                                    {item.color_nm}
                                </h3>
                                <div className="grid grid-cols-[65%_35%]">
                                    <div className="flex items-center justify-end overflow-auto x">
                                        <label className=" font-semibold text-sm text-gray-700 px-2">가중치</label>
                                        <input
                                            name="range_weight"
                                            type="number"
                                            placeholder="0.00"
                                            value={getRangeWeight(item.color_type)}
                                            MAX_LENGTH={MAX_LENGTH}
                                            className="block w-28 rounded border-0 py-1.5 text-gray-900 text-right ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                                            onChange={(e) => {
                                                handleOnChangeRangeWeight(item.color_type, e.target.value);
                                            }}
                                        />
                                    </div>
                                    <div className="flex items-center justify-end">
                                        <label className="text-nowrap font-semibold text-sm text-gray-700 px-2">사용여부</label>
                                        <Switch
                                            checked={getUseYn(item.color_type)}
                                            className={
                                                "group relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2 data-[checked]:bg-blue-600 z-0"
                                            }
                                            onChange={(val) => setUseYn(item.color_type, val)}
                                        >
                                            <span
                                                aria-hidden="true"
                                                className="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
                                            />
                                        </Switch>
                                        <button
                                            type="button"
                                            className="rounded inline-flex gap-x-1 items-center justify-center  px-3 py-2 text-sm font-semibold bg-slate-100 text-gray-500  hover:text-gray-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                                            onClick={() => {
                                                toggleExpand(item.color_type);
                                            }}
                                        >
                                            {isExpanded(item.color_type) ? (
                                                <CiSquarePlus className="-ml-0.5 h-6 w-6" aria-hidden="true" />
                                            ) : (
                                                <CiSquareMinus className="-ml-0.5 h-6 w-6" aria-hidden="true" />
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div
                                className={classNames(
                                    isExpanded(item.color_type) ? "max-h-0" : "",
                                    `overflow-hidden min-w-full divide-y divide-gray-300 shadow-sm ring-1 ring-black ring-opacity-5 sm:rounded-sm`
                                )}
                            >
                                <table className="min-w-full min-h-full">
                                    <thead className="bg-gray-50">
                                        <tr>
                                            <th
                                                scope="col"
                                                className="min-w-48 w-48 px-5 py-3 text-left text-sm font-semibold text-gray-900"
                                            >
                                                단계
                                            </th>
                                            <th scope="col" className="min-w-16 px-5 py-3 text-center text-sm font-semibold text-gray-900">
                                                사용여부
                                            </th>
                                            <th
                                                scope="col"
                                                className="min-w-36 w-32 px-3 py-3 text-end text-sm font-semibold text-gray-900"
                                            >
                                                기존점
                                            </th>
                                            <th
                                                scope="col"
                                                className="min-w-36 w-32 px-3 py-3 text-end text-sm font-semibold text-gray-900"
                                            >
                                                범위 시작
                                            </th>
                                            <th
                                                scope="col"
                                                className="min-w-36 w-32 px-3 py-3 text-end text-sm font-semibold text-gray-900"
                                            >
                                                범위 끝
                                            </th>
                                            <th scope="col" className="w-6/12"></th>
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y divide-gray-200 bg-white min-h-full">
                                        {getTableItems(item.color_type).map((dtl, idx) => (
                                            <tr key={idx}>
                                                <td className="whitespace-nowrap py-2 pl-5 pr-3 text-sm font-bold ">
                                                    <label className="text-gray-800">{dtl.insp_level} </label>
                                                    <label className="text-gray-400">{"(" + dtl.strip_result + ")"}</label>
                                                </td>
                                                <td className="whitespace-nowrap h-full py-2 px-3 text-sm font-medium text-gray-500 text-center">
                                                    <input
                                                        type="checkbox"
                                                        className="h-5 w-5 rounded border-gray-300 text-blue-600 focus:ring-blue-600"
                                                        checked={dtl.use_in_calculate_yn === "Y"}
                                                        onChange={(e) => {
                                                            // console.log("Checbox value => ", e.target.checked);
                                                            handleToggleValue(
                                                                item.color_type,
                                                                dtl.insp_level,
                                                                "use_in_calculate_yn",
                                                                e.target.checked
                                                            );
                                                        }}
                                                    />
                                                </td>
                                                <td className="whitespace-nowrap py-2 px-3 text-sm font-medium text-gray-500">
                                                    <input
                                                        name="range_original"
                                                        type="number"
                                                        placeholder="0.00"
                                                        value={dtl.range_original}
                                                        MAX_LENGTH={MAX_LENGTH}
                                                        className="block w-full rounded border-0 py-1.5 text-gray-900 text-right ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                                                        onChange={(e) => {
                                                            handleValueChange(
                                                                item.color_type,
                                                                dtl.insp_level,
                                                                "range_original",
                                                                e.target.value
                                                            );
                                                        }}
                                                    />
                                                </td>
                                                <td className="whitespace-nowrap py-2 px-3 text-sm font-medium text-gray-500">
                                                    <input
                                                        name="range_s"
                                                        type="number"
                                                        placeholder="0.00"
                                                        value={dtl.range_s}
                                                        MAX_LENGTH={MAX_LENGTH}
                                                        className="block w-full rounded border-0 py-1.5 text-gray-900 text-right ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                                                        onChange={(e) => {
                                                            handleValueChange(item.color_type, dtl.insp_level, "range_s", e.target.value);
                                                        }}
                                                    />
                                                </td>
                                                <td className="whitespace-nowrap py-2 px-3 text-sm font-medium text-gray-500">
                                                    <input
                                                        name="range_e"
                                                        type="number"
                                                        placeholder="0.00"
                                                        value={dtl.range_e}
                                                        MAX_LENGTH={MAX_LENGTH}
                                                        className="block w-full rounded border-0 py-1.5 text-gray-900 text-right ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                                                        onChange={(e) => {
                                                            handleValueChange(item.color_type, dtl.insp_level, "range_e", e.target.value);
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
